import { Controller } from "@hotwired/stimulus";

// Affiche un spinner plein écran pendant la génération et le téléchargement
// d'un fichier. Utilise fetch() directement pour maîtriser précisément le
// cycle de vie : le spinner disparaît dès que le fichier est prêt côté client.
export default class extends Controller {
  static targets = ["spinner"];

  async download(event) {
    event.preventDefault();

    this.#showSpinner();

    try {
      //Le navigateur lance une requête vers l’URL du lien, comme si on téléchargeait le fichier
      // mais via fetch()
      const response = await fetch(event.currentTarget.href, { credentials: "same-origin" });

      if (!response.ok) throw new Error(`Erreur serveur : ${response.status}`);

      const blob = await response.blob();
      const filename = "attestation_souscription_contrat.pdf";

      // Le navigateur crée une URL temporaire vers le fichier téléchargé en mémoire.
      const objectUrl = URL.createObjectURL(blob);

      // Le code crée un faux lien invisible, lui donne le fichier à télécharger, puis déclenche
      // automatiquement le clic.
      const anchor = document.createElement("a");
      anchor.href = objectUrl;
      anchor.download = filename;
      anchor.click();

      // On libère l’URL temporaire pour éviter de garder le fichier en mémoire.
      URL.revokeObjectURL(objectUrl);
    } finally {
      this.#hideSpinner();
    }
  }

  // -- private --

  #showSpinner() {
    this.spinnerTarget.hidden = false;
  }

  #hideSpinner() {
    this.spinnerTarget.hidden = true;
  }
}

